import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton, Box, Tooltip, Button, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteRow from "../../components/DeleteRow";
import Detail from "../../main/detail/Detail";
import { useNavigate, useLocation } from "react-router-dom";
import { UseCompetitors } from "./UseCompetitors";
import ProgressCom from "../../components/ProgressCom";
import { UseMyPC } from "../../hooks/UseMyPC";
import EditIcon from "@mui/icons-material/Edit";
import CustomPagination from "../../components/CustomPagination";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function EditCompetitors(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const { getCompetitorDataListById, deleteCompetitor } = UseCompetitors();
  const { refresh } = UseMyPC();
  const [comRes, setComRes] = useState();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  useEffect(() => {
    if (location.state && location.state.id) {
      getCompetitorDataListById(location.state.id, (competitors) => {
        setComRes(competitors);
      });
    }
  }, []);

  const newFunc = () => {
    return navigate("/competitors/editcompetitors/addOneCompetitor", {
      state: {
        id: location.state.id,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 70,
      headerName: "ID",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: " عنوان ",
      width: 130,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "url",
      headerName: "url",
      width: 400,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", direction: "rtl" }}
          >
            {cellValues.row.url}
          </Typography>
        );
      },
    },
    {
      field: "parameter1",
      headerName: "پارامتر 1",
      width: 190,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.parameter1}
          </Typography>
        );
      },
    },
    {
      field: "parameter2",
      headerName: "پارامتر 2",
      width: 190,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.parameter2}
          </Typography>
        );
      },
    },
    {
      field: "عملیات",
      headerName: "عملیات",
      width: 100,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex" }}>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.title,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  return navigate(
                    "/competitors/editcompetitors/editOneCompetitor",
                    {
                      state: {
                        model: cellValues.row,
                        id: location.state.id,
                      },
                    }
                  );
                }}
              >
                <EditIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },

    ,
  ];

  return (
    <Detail
      breadChilds={{
        backButtonDef: true,
        backURL: "/competitors",
        title: "محصولات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/competitors" },
          { name: "ویرایش رقبای محصول", url: "/competitors/editcompetitors" },
        ],
      }}
    >
      {comRes ? (
        <DataGrid
          className="ltr-grid"
          columns={columns}
          rows={comRes.competitors}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: { isLtr: true, newFunc: newFunc },
          }}
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"رقیب"}
        callback={() => {
          setProgress(true);
          deleteCompetitor(deleteState.id, () => {
            getCompetitorDataListById(location.state.id, (competitors) => {
              setComRes(competitors);
            });
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
